<template>
  <main>
    <h1>{{ $t('top-scoring-lists.selection-view-title') }}</h1>

    <div v-if="isLoading" class="loading-animation">
      <BusyIndicator />
    </div>

    <NotificationBanner
      v-else-if="errorMessage"
      :message="errorMessage"
      is-danger
    />

    <TopScoringListSelector
      v-else
      :available-lists="topScoringLists.available"
      @select-list="selectList"
    />
  </main>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TopScoringListSelector from '@/components/widgets/public/TopScoringListSelector.vue'
import { useTopScoringListsStore } from '@/store/public/top-scoring-lists'
import { getErrorMessage } from '@/utils/error-handling'

const router = useRouter()
const topScoringLists = useTopScoringListsStore()

const errorMessage = ref<string | null>()
const isLoading = ref<boolean>(false)

onMounted(async (): Promise<void> => {
  isLoading.value = true

  try {
    await topScoringLists.fetch()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching available top lists: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

async function selectList(id: number): Promise<void> {
  await router.push({ path: `/top-scoring-lists/${id}` })
}
</script>

<style lang="scss" scoped>
.loading-animation {
  padding: 2em 0;
  font-size: 3em;
  text-align: center;
}
</style>
